/*
 * $Id:: index.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory, useLocation } from 'react-router-dom';

import { GLOBALS_SLICE_NAME } from '../../../app/constants';
import { ReactComponent as InfoIcon } from '../../../assets/images/info_24px.svg';
import { t } from '../../../providers';
import { SLICE_NAME as SSO_SLICE_NAME } from '../../SSOPage/constants';
import helpers from '../../SSOPage/SSOHelpers';
import { response as responseSlice } from '../../SSOPage/ssoSlice';
import { credentials as creds, error as verifyError, loading as isLoading, registration } from '../authenticationSlice';
import AuthContainer from '../components/AuthContainer';
import RequestResult from '../components/RequestResult';
import { SLICE_NAME } from '../constants';
import VerificationForm from './components';

const AccountVerificationPage = () => {
    const { token } = useParams();
    const credentials = useSelector(creds);
    const history = useHistory();
    const error = useSelector(verifyError);
    const loading = useSelector(isLoading);
    const result = useSelector(registration);
    const response = useSelector(responseSlice);

    const dispatch = useDispatch();

    const { pathname } = useLocation();
    const splPath = pathname.split('/');
    const isChildAccount = splPath.length > 1 && splPath[1] === 'child';

    useEffect(() => {
        if (!token && (!credentials || !credentials.username)) history.push('/login');
    }, [token, credentials, history]);

    useEffect(() => {
        if (!error && result && result.fromAction) {
            const { username, password, challenge } = credentials || {};
            if (result.fromAction === 'verifyAccount' && username && password && result.message !== 'registration.token.not.valid') {
                dispatch({ type: `${SLICE_NAME}/registration`, payload: {} });
                dispatch({ type: `${SSO_SLICE_NAME}/login`, payload: { username, password, challenge } });
            }
        }
    }, [dispatch, result, credentials, error]);

    useEffect(() => {
        if (response && response.redirect) {
            dispatch({ type: `${SLICE_NAME}/response`, payload: null });
            dispatch({ type: `${GLOBALS_SLICE_NAME}/globalLoading`, payload: true });
            helpers.verifyLoginToSSO(response.redirect);
        }
    }, [response, dispatch]);

    useEffect(() => {
        return () => {
            dispatch({ type: `${SLICE_NAME}/credentials`, payload: {} });
            dispatch({ type: `${SLICE_NAME}/registration`, payload: {} });
            dispatch({ type: `${SLICE_NAME}/error`, payload: null });
        };
    }, [dispatch]);

    const requestNewCode = () => {
        const body = {};
        if (credentials && credentials.username) body.userName = credentials.username;
        if (token) body.token = token;
        if (!body.userName && !body.token) return;
        dispatch({ type: `${SLICE_NAME}/requestNewVerificationCode`, payload: body });
    };

    const verifyAccount = (payload) => {
        dispatch({ type: `${SLICE_NAME}/verifyAccount`, payload });
    };

    const backToLogin = () => {
        dispatch({ type: `${SLICE_NAME}/credentials`, payload: null });
        dispatch({ type: `${SLICE_NAME}/registration`, payload: {} });
        history.push('/login');
    };
    let renderBody;
    if (!error && result && result.fromAction === 'requestNewVerificationCode') {
        renderBody = <RequestResult action={backToLogin} message={'resend.activation.email.success'} button={'back.to.login'} />;
    } else if (!error && result && result.fromAction === 'verifyAccount') {
        renderBody = <RequestResult action={backToLogin} message={'account.successfully.verified'} button={'back.to.login'} />;
    } else {
        renderBody = (
            <VerificationForm
                token={token}
                error={error}
                requestNewCode={requestNewCode}
                verifyAccount={verifyAccount}
                includePassword={isChildAccount}
            />
        );
    }

    return (
        <AuthContainer preTitle={<InfoIcon />} title={t('verify.account.title')}>
            {loading ? <CircularProgress /> : renderBody}
        </AuthContainer>
    );
};

export default AccountVerificationPage;
